<div class="section">
  <h4 *ngIf="heading" class="mb-2">{{ heading }}</h4>
  <div class="fields row g-0 gx-lg-2">
    <ng-content></ng-content>
  </div>
</div>
